import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Container } from 'components/layout/Container';
import { Language } from 'language/Language';
import { strings } from './strings';
import UserMenu from '../menu/UserMenu';
import './_userContainer.scss';

const UserContainer = ({ children }) => {
  const language = Language();
  const { countryUser } = useSelector((state) => state.siteInfo);
  return (
    <Container>
      {countryUser === 'JP'
          && (
            <div className='user__link'>
              {language === 'japan'
                ? (
                  <p>
                    {strings[language].question}
                    <Link to='/ja/voucher'>{strings[language].here}</Link>
                    {strings[language].question2}
                  </p>
                )
                : (
                  <p>
                    {strings[language].question}
                    <Link to='/voucher'>{strings[language].here}</Link>
                  </p>
                )}
            </div>
          )}
      <div className='user-container'>
        <UserMenu />
        {children}
      </div>
    </Container>
  );
};

UserContainer.propTypes = {
  children: PropTypes.element,
};

export default UserContainer;
